import { DEFAULT_PAGE_SIZE } from '@utils/line-items';
import type { LotPagination } from 'types';

/** A lot's page before its first read: page 1 at the default size, nothing loaded yet. */
export const DEFAULT_LOT_PAGINATION: LotPagination = {
  currentPage: 1,
  loadedPage: 1,
  loadedPageSize: DEFAULT_PAGE_SIZE,
  loads: 0,
  pageIds: [],
  pageSize: DEFAULT_PAGE_SIZE,
  total: 0,
};
